import type { DayHours, Stat } from '../types/shop';

export const shop = {
  name: 'Helena Body and Paint',
  phone: '(406) 442-8170',
  phoneHref: 'tel:+14064428170',
  email: 'estimates@helenabodyandpaint.com',
  addressLine1: '829 N Warren St',
  addressLine2: 'Helena, MT 59601',
  mapsHref: 'https://maps.google.com/?q=829+N+Warren+St+Helena+MT+59601',
  rating: '4.9',
  reviewCount: 318,
};

export const hours: DayHours[] = [
  { day: 'Monday', dayIndex: 1, open: '07:30', close: '17:30' },
  { day: 'Tuesday', dayIndex: 2, open: '07:30', close: '17:30' },
  { day: 'Wednesday', dayIndex: 3, open: '07:30', close: '17:30' },
  { day: 'Thursday', dayIndex: 4, open: '07:30', close: '17:30' },
  { day: 'Friday', dayIndex: 5, open: '07:30', close: '17:30' },
  { day: 'Saturday', dayIndex: 6, open: '09:00', close: '13:00' },
  { day: 'Sunday', dayIndex: 0, open: null, close: null },
];

export const heroFacts: Stat[] = [
  { value: 'Since 1948', label: 'serving Helena drivers' },
  { value: 'All insurers', label: 'claims handled for you' },
  { value: 'I-CAR Gold', label: 'Class certified shop' },
];

export const shopHistory: Stat[] = [
  { value: '1948', label: 'Opens its doors in Helena on January 1' },
  { value: '1962', label: 'Ron Kennaugh starts working in the shop' },
  { value: '1974', label: 'Ron purchases the business' },
  { value: '1981', label: 'Incorporated as Helena Body & Paint, Inc.' },
  { value: 'Today', label: 'Owned and managed by Jesse Vulk' },
];

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/6db5e83f-3996-4e83-9fe6-1c7efc493f85.jpg',
  collision: 'https://cdn.magicpatterns.com/patterns/generated-images/a6e362bc-bcf9-4fec-8338-964f8bae21ab.jpg',
  detail: 'https://cdn.magicpatterns.com/patterns/generated-images/16795ece-9370-447b-b720-58ebe0bc7d67.jpg',
  shopFront: 'https://cdn.magicpatterns.com/patterns/generated-images/61141fd1-becb-4295-9eb5-a477286e3aa3.jpg',
};
